module.exports = __webpack_public_path__ + "img/xiaoman5.c358e8ed.png";